import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false, requirePaid = false, requirePaidMobile = false }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-[60vh] flex items-center justify-center" data-testid="auth-loading">
                <div className="ui-heading text-sm text-ink-soft">Loading…</div>
            </div>
        );
    }
    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }
    if (adminOnly && user.role !== "admin") {
        return <Navigate to="/" replace />;
    }
    if (requirePaid && !user.is_paid && user.role !== "admin") {
        return <Navigate to="/pricing" replace />;
    }
    // Mobile equivalent: send to /unlock instead of /pricing
    if (requirePaidMobile && !user.is_paid && user.role !== "admin") {
        return <Navigate to="/unlock" replace />;
    }
    return children;
}
